// Toestand die over schermen heen geldt: de gekozen klant en de ingeklapte zijbalk. Anders dan in het prototype
// blijft een klantkeuze staan als je van scherm wisselt, en ook na herladen (per browser).
import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

interface AppState {
  klant: string | null;
  setKlant: (id: string | null) => void;
  sideMin: boolean;
  toggleSide: () => void;
  newTaskOpen: boolean;
  setNewTaskOpen: (open: boolean) => void;
}

const Ctx = createContext<AppState | null>(null);
const load = (k: string) => { try { return window.localStorage.getItem(k); } catch { return null; } };
const save = (k: string, v: string | null) => { try { if (v === null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v); } catch { /* privévenster */ } };

export function AppStateProvider({ children }: { children: ReactNode }) {
  const [klant, setKlant] = useState<string | null>(() => load("tp.klant"));
  const [sideMin, setSideMin] = useState(() => load("tp.side") === "1");
  const [newTaskOpen, setNewTaskOpen] = useState(false);
  useEffect(() => save("tp.klant", klant), [klant]);
  useEffect(() => save("tp.side", sideMin ? "1" : null), [sideMin]);
  return (
    <Ctx.Provider value={{ klant, setKlant, sideMin, toggleSide: () => setSideMin((v) => !v), newTaskOpen, setNewTaskOpen }}>
      {children}
    </Ctx.Provider>
  );
}

export function useAppState(): AppState {
  const v = useContext(Ctx);
  if (!v) throw new Error("AppStateProvider ontbreekt");
  return v;
}
